import { useContext } from "react";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import TableContext from "context/table/tableContext";

import TableItem from "../TableItem";

const TableMobile = () => {
    const { gray100 } = colors;

    const { rows, isTableLoading, idType } = useContext(TableContext);

    return (
        <div
            css={css({
                background: gray100,
                opacity: isTableLoading ? "0.4" : "1",
                transition: "opacity 300ms ease-out",

                "& > div + div": {
                    marginTop: "8px"
                }
            })}
        >
            {rows.map((row: any) => (
                <TableItem key={row[idType]} data={row} />
            ))}
        </div>
    );
};

export default TableMobile;
